import { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";

export const ProductStrip = () => {
  const [products, setProducts] = useState([]);
  const [brands, setBrands] = useState([]);
  const scroller = useRef(null);

  useEffect(() => {
    api.get("/products").then((r) => {
      const sorted = [...r.data].sort((a, b) => (b.badge ? 1 : 0) - (a.badge ? 1 : 0));
      setProducts(sorted.slice(0, 12));
    }).catch(() => {});
    api.get("/brands").then((r) => setBrands(r.data)).catch(() => {});
  }, []);

  const brandName = (slug) => brands.find((b) => b.slug === slug)?.name || slug;
  const scroll = (dir) => scroller.current?.scrollBy({ left: dir * 640, behavior: "smooth" });

  if (!products.length) return null;

  return (
    <section className="py-16 border-b border-zinc-200 bg-white" data-testid="product-strip">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="flex items-end justify-between mb-10">
          <div>
            <p className="text-xs uppercase tracking-[0.5em] text-gold mb-3">Right Now</p>
            <h2 className="font-serif font-medium text-3xl sm:text-4xl text-zinc-900 tracking-tight">
              Flying off the <em className="text-gold">shelf</em>
            </h2>
          </div>
          <div className="hidden md:flex gap-2">
            <button onClick={() => scroll(-1)} data-testid="strip-prev" aria-label="Previous" className="p-3 border border-zinc-200 text-zinc-500 hover:border-gold hover:text-gold transition-colors duration-300">
              <ChevronLeft size={16} />
            </button>
            <button onClick={() => scroll(1)} data-testid="strip-next" aria-label="Next" className="p-3 border border-zinc-200 text-zinc-500 hover:border-gold hover:text-gold transition-colors duration-300">
              <ChevronRight size={16} />
            </button>
          </div>
        </div>
      </div>
      <div
        ref={scroller}
        className="flex gap-6 overflow-x-auto snap-x snap-mandatory px-6 md:px-12 pb-4 max-w-[1600px] mx-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        data-testid="product-strip-scroller"
      >
        {products.map((p, i) => (
          <div key={p.id} className="w-64 md:w-72 shrink-0 snap-start">
            <ProductCard product={p} brandName={brandName(p.brand_slug)} index={i} />
          </div>
        ))}
      </div>
    </section>
  );
};
